import React from 'react';

import {
  Container,
  ContentContainer,
  FlexWrapper,
  Title,
} from './SpaceSettings.styled';
import SpaceSettingsTabPanel from './SpaceSettingsTabPanel.container';
import BackButton from './BackButton.container';

const SpaceSettings = () => (
  <Container>
    <BackButton />
    <FlexWrapper>
      <ContentContainer>
        <Title>Space settings</Title>
        <SpaceSettingsTabPanel />
      </ContentContainer>
    </FlexWrapper>
  </Container>
);

export default SpaceSettings;
